// extracted by mini-css-extract-plugin
export var active = "faqs-module--active--0d9c4";
export var anchorContainer = "faqs-module--anchorContainer--278bd";
export var anchorLink = "faqs-module--anchorLink--ab1bd";
export var answer = "faqs-module--answer--08308";
export var arrowIcon = "faqs-module--arrowIcon--1538c";
export var arrowWrapper = "faqs-module--arrowWrapper--30dc3";
export var container = "faqs-module--container--5fa69";
export var copied = "faqs-module--copied--edba0";
export var copiedAnchor = "faqs-module--copiedAnchor--568bd";
export var expander = "faqs-module--expander--73395";
export var faqItem = "faqs-module--faqItem--76899";
export var list = "faqs-module--list--d8f30";
export var questionButton = "faqs-module--questionButton--c0050";
export var questionContainer = "faqs-module--questionContainer--f2d26";
export var questionGroup = "faqs-module--questionGroup--d075f";
export var questionText = "faqs-module--questionText--ec1c3";
export var questionTextContainer = "faqs-module--questionTextContainer--637a6";
export var questionWrapper = "faqs-module--questionWrapper--c49a4";
export var title = "faqs-module--title--a70b5";
export var visible = "faqs-module--visible--df97c";